
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
:host{
  display:block;
  --top-menu-min-height:116px;
}

.global-header{
  background-color:var(--brand-primary-dark-blue);
  position:relative;
  z-index:10;

  --mobile-top-bar-height:100px;
  --outline-button--primary-padding--computed:0.75rem;
}

header.is-open{
  position:fixed;
  right:0px;
  left:0px;
  top:0;
  bottom:0px;
  z-index:10;
}

.top-row{
  display:flex;
  align-items:center;
  gap:var(--spacing-2);
  position:relative;
  height:var(--mobile-top-bar-height);
  padding:var(--spacing-2) 0;
}

@media (min-width: 1280px){

.top-row{
    padding-bottom:var(--spacing-2);
    height:auto;
    min-height:var(--top-menu-min-height)
}
  }

.utility-wrapper{
  top:var(--spacing-4);
  right:0;
  position:absolute;
  padding-right:var(--spacing-11);
}

::slotted([slot='main-navigation']){
  position:relative;
  z-index:3;
}

.logo{
  flex-grow:1;
  align-self:auto;
  align-self:var(--logo-align-self, auto);
}

.logo ::slotted(*){
    display:inline-block;
    max-width:230px;
    width:100%;
  }

@media (min-width: 1280px){

.logo ::slotted(*){
      max-width:100%
  }
    }

.logo a:focus{
    outline:2px solid var(--brand-white);
    outline-offset:2px;
  }

@media (min-width: 1536px){
    div[slot='logo'] img{
      width:280px;
    }
  }

.utility-navigation{
  padding:var(--spacing-8) 0;
}

@media (min-width: 1280px){

.utility-navigation{
    padding:0;
    border-right:2px solid var(--brand-green-900);
    border-right:var(--utility-nav-border, 2px solid var(--brand-green-900))
}
  }

.search-wrapper.desktop{
  position:absolute;
  right:0;
  top:var(--spacing-3);
  transition:all 0.3s ease-in-out;
}

.search-wrapper.desktop.expanded{
    border:none;
  }

.search-container{
  display:flex;
  flex-direction:row-reverse;
  align-items:center;
  overflow:hidden;
  right:0;
  border-radius:5px;
  background-color:transparent;
  border:2px solid var(--brand-dark-blue-900);
}

@media (min-width: 1280px){

.search-container{
    background:var(--brand-primary-dark-blue)
}
  }

.search-container:focus,
  .search-container:focus-within,
  .search-container:hover{
    border-color:var(--outline-white);
  }

.search-container.expanded{
    width:100%;
    border-color:var(--outline-white);
    padding-left:1rem;
  }

.search-container .separator{
    height:24px;
    width:2px;
    margin-left:1rem;
    margin-right:0.25rem;
    background-color:var(--brand-green-900);
  }

.search-container .search-button{
    background:transparent;
    border:0;
    color:inherit;
  }

.search-container .search-button:focus-visible{
      border-radius:5px;
      outline:2px solid var(--outline-white);
      outline-offset:-6px;
    }

.search-container .search-form{
    display:none;
    width:100%;
  }

.search-container .search-form.expanded{
      display:unset;
    }

.search-container.expanded .search-form.desktop{
  display:block;
}

.search-container.expanded .search-form.mobile{
  display:flex;
  justify-content:flex-end;
  align-items:center;
  background:var(--brand-primary-dark-blue);
  width:100%;
}

::slotted([slot='search-form']){
  display:flex;
  flex:1;
}

.search-wrapper.mobile{
  margin-bottom:var(--spacing-4);
}

.search-wrapper.mobile .btn{
    display:flex;
    align-items:center;
    justify-content:center;
    margin:var(--spacing-2);
    width:32px;
    height:32px;
  }

.hamburger-menu-trigger.btn.primary{
    background:transparent;
    border:0;
    color:var(--brand-white);
  }

.hamburger-menu-trigger.btn.primary:focus{
      outline:2px solid var(--brand-white);
      outline-offset:2px;
    }

.mobile-hamburger-tray{
  background:var(--brand-primary-dark-blue);
  padding:var(--padding-x);
  display:none;
  overflow:scroll;
}

.mobile-hamburger-tray.expanded{
    display:block;
    position:fixed;
    right:0;
    left:0;
    top:var(--mobile-top-bar-height);
    bottom:0;
  }

.divider{
  height:4px;
  width:100%;
  background-color:var(--brand-blue-400);
  margin-top:var(--spacing-5);
}

.search-form-expanded,
.search-form-item,
#search-query{
  width:100%;
  background-color:var(--brand-primary-dark-blue);
  outline:0;
}
`;